// ==================== RISK FRAMEWORKS ====================

export const TRANSFORMATION_RISKS = {
  organizational: [
    {
      risk: 'Resistance to change',
      impact: 'High',
      probability: 'Medium',
      mitigation: 'Change management program',
      contingency: 'Executive sponsorship escalation',
      owner: 'CHRO',
      indicator: 'Low adoption rates'
    },
    {
      risk: 'Skill shortage',
      impact: 'High',
      probability: 'Medium',
      mitigation: 'Training and partnerships',
      contingency: 'External consultants',
      owner: 'CTO',
      indicator: 'Open positions > 90 days'
    },
    {
      risk: 'Culture clash',
      impact: 'Medium',
      probability: 'Low',
      mitigation: 'Cultural integration program',
      contingency: 'Culture champions',
      owner: 'CEO',
      indicator: 'Employee satisfaction decline'
    }
  ],
  
  technical: [
    {
      risk: 'Data quality issues',
      impact: 'High',
      probability: 'Medium',
      mitigation: 'Data governance framework',
      contingency: 'Data cleansing initiative',
      owner: 'CDO',
      indicator: 'Data quality score < 80%'
    },
    {
      risk: 'Integration complexity',
      impact: 'High',
      probability: 'Medium',
      mitigation: 'API-first approach',
      contingency: 'Middleware solutions',
      owner: 'CIO',
      indicator: 'Integration failures'
    },
    {
      risk: 'Scalability issues',
      impact: 'Medium',
      probability: 'Low',
      mitigation: 'Cloud-native architecture',
      contingency: 'Performance optimization',
      owner: 'CTO',
      indicator: 'Performance degradation'
    }
  ],
  
  financial: [
    {
      risk: 'Budget overrun',
      impact: 'High',
      probability: 'Medium',
      mitigation: 'Phased budgeting',
      contingency: 'Scope reduction',
      owner: 'CFO',
      indicator: 'Spend > 120% of plan'
    },
    {
      risk: 'ROI below expectations',
      impact: 'High',
      probability: 'Low',
      mitigation: 'Value tracking',
      contingency: 'Pivot strategy',
      owner: 'CEO',
      indicator: 'ROI < 100%'
    }
  ],
  
  regulatory: [
    {
      risk: 'Compliance violation',
      impact: 'Critical',
      probability: 'Low',
      mitigation: 'Compliance framework',
      contingency: 'Legal counsel',
      owner: 'CCO',
      indicator: 'Audit findings'
    },
    {
      risk: 'Data privacy breach',
      impact: 'Critical',
      probability: 'Low',
      mitigation: 'Security controls',
      contingency: 'Incident response',
      owner: 'CISO',
      indicator: 'Security incidents'
    }
  ]
};

export const RISK_SCORING = {
  impactLevels: {
    'Critical': 5,
    'High': 4,
    'Medium': 3,
    'Low': 2,
    'Negligible': 1
  },
  probabilityLevels: {
    'Very Likely': 5,
    'Likely': 4,
    'Medium': 3,
    'Unlikely': 2,
    'Very Unlikely': 1
  },
  riskScore: (impact, probability) => {
    const impactScore = RISK_SCORING.impactLevels[impact] || 3;
    const probScore = RISK_SCORING.probabilityLevels[probability] || 3;
    return impactScore * probScore;
  },
  riskLevel: (score) => {
    if (score >= 20) return 'Critical';
    if (score >= 15) return 'High';
    if (score >= 10) return 'Medium';
    return 'Low';
  }
};